import React, {useRef} from "react";
import {gsap, Power2} from "gsap";
import {Link, useNavigate} from "react-router-dom";
import "./MagneticCircleButton.css";

const MagneticCircleButton = ({
  className,
  text = "Explore",
  text2 = "My Work",
  to = "/",
  target,
  href,
}) => {
  const wrapperRef = useRef(null);
  const btnRef = useRef(null);
  const navigate = useNavigate(); // for routing

  const handleMouseMove = (e) => {
    const wrapper = wrapperRef.current;
    const target = btnRef.current;

    if (!wrapper || !target) return;

    const boundingRect = wrapper.getBoundingClientRect();
    const relX = e.clientX - boundingRect.left;
    const relY = e.clientY - boundingRect.top;

    const movement = 100;
    const xMove =
      ((relX - boundingRect.width / 2) / boundingRect.width) * movement;
    const yMove =
      ((relY - boundingRect.height / 2) / boundingRect.height) * movement;

    gsap.to(target, {
      duration: 0.3,
      x: xMove,
      y: yMove,
      rotation: 0,
      ease: Power2.easeOut,
    });

    if (window.$ball && window.$ballPos) {
      const ballMovement = 2;
      window.$ballPos.x =
        boundingRect.left +
        boundingRect.width / 2 +
        (relX - boundingRect.width / 2) / ballMovement;
      window.$ballPos.y =
        boundingRect.top +
        boundingRect.height / 2 +
        (relY - boundingRect.height / 2) / ballMovement;

      gsap.to(window.$ball, {
        duration: 0.3,
        x: window.$ballPos.x,
        y: window.$ballPos.y,
      });
    }
  };

  const handleMouseLeave = () => {
    if (btnRef.current) {
      gsap.to(btnRef.current, {
        duration: 0.3,
        x: 0,
        y: 0,
        rotation: -20,
        ease: Power2.easeOut,
      });
    }
  };

  const handleClick = () => {
    navigate(to);
  };

  return href ? (
    <a
      className={`${className} big-round-ptn margin-top-20 margin-left-xlg-10-p`}
      target={target}
      href={href}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
    >
      <div
        className="magnetic-wrap"
        ref={wrapperRef}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{cursor: "pointer"}}
      >
        <div className="big-round-btn-holder magnetic-magnetic-item">
          <div className="big-round-btn-inner" ref={btnRef}>
            {text}
            <br />
            {text2}
          </div>
        </div>
      </div>
    </a>
  ) : to ? (
    <Link
      className="big-round-ptn margin-top-20 margin-left-xlg-10-p"
      to={to}
      target={target}
    >
      <div
        className="magnetic-wrap"
        ref={wrapperRef}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{cursor: "pointer"}}
      >
        <div className="big-round-btn-holder magnetic-magnetic-item">
          <div className="big-round-btn-inner" ref={btnRef}>
            {text}
            <br />
            {text2}
          </div>
        </div>
      </div>
    </Link>
  ) : (
    <div
      className="big-round-ptn margin-top-20 margin-left-xlg-10-p"
      style={{pointerEvents: "none", opacity: 0.6}}
    >
      <div
        className="magnetic-wrap"
        ref={wrapperRef}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        <div className="big-round-btn-holder magnetic-magnetic-item">
          <div className="big-round-btn-inner" ref={btnRef}>
            {text}
            <br />
            {text2}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MagneticCircleButton;
